<h2 mat-dialog-title class="title">{{ title }}</h2>
<mat-dialog-content class="body">{{ body }}</mat-dialog-content>
<mat-dialog-actions>
  @if (buttonTextNo) {
    <button mat-button mat-dialog-close class="buttonTextNo">{{ buttonTextNo }}</button>
  }
  @if (buttonTextYes) {
    <button mat-button [mat-dialog-close]="true" class="buttonTextYes">{{ buttonTextYes }}</button>
  }
</mat-dialog-actions>